// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductImageUploadPopUp_wrapper__jqsGj"};